function formatTel(number) {
  if (!number) return '';

  // 숫자만 추출
  const digits = number.replace(/\D/g, '');

  // 휴대폰 (010, 011, 016~019)
  if (/^01[016789]\d{7,8}$/.test(digits)) {
    if (digits.length === 10) {
      // 010-000-0000
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    } else {
      // 010-0000-0000
      return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }

  // 서울 (02로 시작)
  if (/^02\d{7,8}$/.test(digits)) {
    if (digits.length === 9) {
      // 02-000-0000
      return digits.replace(/(02)(\d{3})(\d{4})/, '$1-$2-$3');
    } else {
      // 02-0000-0000
      return digits.replace(/(02)(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }

  // 기타 지역번호 (03~, 04~, 05~, 06~, 07~, 09~ 등)
  if (/^0[3-9][0-9]\d{7,8}$/.test(digits)) {
    if (digits.length === 10) {
      // 031-000-0000
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    } else {
      // 031-0000-0000
      return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }

  // 위 조건에 안 맞는 경우 그대로 반환
  return number;
}

function formattedRegDtim(input) {
    if (!input || input.length !== 14) return input;

    const y = input.slice(0, 4);
    const m = input.slice(4, 6);
    const d = input.slice(6, 8);
    const h = input.slice(8, 10);
    const min = input.slice(10, 12);
    const s = input.slice(12, 14);

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
}

function formattedYYYYMMDD(input) {
    if (!input) return input;
    if (input.length === 14 || input.length === 8) {
        const y = input.slice(0, 4);
        const m = input.slice(4, 6);
        const d = input.slice(6, 8);
        return `${y}-${m}-${d}`;
    }
    if (input.length === 6) {
        const y = input.slice(0, 4);
        const m = input.slice(4, 6);
        return `${y}-${m}`;
    }
    return input;
}

function formatCorpOrBizNumber(input) {
    if (!input) return input;
    // 숫자만 추출
    const numbersOnly = input.replace(/[^0-9]/g, '');

    // 법인번호: 6자리-7자리 (총 13자리)
    if (numbersOnly.length === 13) {
        const corp1 = numbersOnly.slice(0, 6);
        const corp2 = numbersOnly.slice(6, 13);
        return `${corp1}-${corp2}`;
    }
    // 사업자번호: 3자리-2자리-5자리 (총 10자리)
    if (numbersOnly.length === 10) {
        const biz1 = numbersOnly.slice(0, 3);
        const biz2 = numbersOnly.slice(3, 5);
        const biz3 = numbersOnly.slice(5, 10);
        return `${biz1}-${biz2}-${biz3}`;
    }
    // 지원하지 않는 길이일 때 원본 반환
    return input;
}

function formatNumberWithCommas(input) {
  // 숫자로 변환 가능할 때만 포맷 적용
  if (!isNaN(input) && input !== null && input !== '') {
    // 소수점 처리도 포함
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return input;
}

export { formatTel, formattedRegDtim, formatCorpOrBizNumber, formattedYYYYMMDD, formatNumberWithCommas }